/**
 * Row kebab menu — frame 17. Disabled while the row is mid-sync (spec:
 * "Resync disabled" during Syncing).
 */
import React, { useMemo } from "react";
import DropdownMenu from "../../theme/untitled/DropdownMenu/DropdownMenu";
import IconButton from "../../theme/untitled/IconButton/IconButton";
import Icon from "../../theme/untitled/icons/Icon";
import Badge from "../../theme/untitled/Badge/Badge";
import styles from "./ConnectionRow.module.scss";

const RowMenu = ({
  integration,
  syncing,
  onEditSettings,
  onResync,
  onFullResync,
  onDisconnect,
}) => {
  const items = useMemo(
    () => [
      {
        key: "edit",
        label: "Edit scopes and calendars",
        icon: <Icon name="Settings01" size={16} />,
        onClick: () => onEditSettings(integration),
      },
      {
        key: "resync",
        label: "Resync now",
        icon: <Icon name="RefreshCcw01" size={16} />,
        disabled: syncing,
        onClick: () => onResync(integration),
      },
      { type: "divider" },
      {
        key: "full-resync",
        label: (
          <span className={styles.menuLabelRow}>
            Full re-sync
            <Badge color="warning" size="sm">
              Wipes data
            </Badge>
          </span>
        ),
        icon: <Icon name="RefreshCcw05" size={16} />,
        disabled: syncing,
        onClick: () => onFullResync(integration),
      },
      {
        key: "disconnect",
        label: "Disconnect",
        icon: <Icon name="Trash01" size={16} />,
        destructive: true,
        onClick: () => onDisconnect(integration),
      },
    ],
    [integration, syncing, onEditSettings, onResync, onFullResync, onDisconnect]
  );

  return (
    <DropdownMenu
      trigger={
        <IconButton icon={<Icon name="DotsVertical" />} label="More actions" />
      }
      items={items}
    />
  );
};

export default RowMenu;
